import { useState, useEffect } from 'react';

interface WindowParameters {
  playerHeight: number;
  windowWidth: number;
}

export function useWindowResize() {
  const [actualParameters, setActualParameters] = useState<WindowParameters>({
    playerHeight: 0,
    windowWidth: window.innerWidth,
  });

  useEffect(() => {
    let resizeTimeout: ReturnType<typeof setTimeout> | null = null;

    function actualResizeHandler() {
      // @ts-ignore
      if (window.playerHeight) {
        // @ts-ignore
        const playerHeight = window.playerHeight;
        setActualParameters({
          playerHeight,
          windowWidth: window.innerWidth,
        });
      }
    }

    function resizeThrottler() {
      if (!resizeTimeout && window.innerWidth <= 992) {
        resizeTimeout = setTimeout(() => {
          resizeTimeout = null;
          actualResizeHandler();
        }, 66);
      }
    }

    window.addEventListener('resize', resizeThrottler, false);

    return () => {
      window.removeEventListener('resize', resizeThrottler, false);
      if (resizeTimeout) clearTimeout(resizeTimeout);
    };
  }, []);

  useEffect(() => {
    // @ts-ignore
    const playerHeight = window.playerHeight;
    setActualParameters({
      playerHeight,
      windowWidth: window.innerWidth,
    });
    // @ts-ignore
  }, [window.playerHeight]);

  return actualParameters;
}
